import React from 'react';
import { PII_FIELD_TYPES } from '../common/constants';
import usePiiReveal from '../hooks/usePiiReveal';
import RevealPiiButton from './RevealPiiButton';

const RevealPiiValue = ({
  value,
  userId,
  field = PII_FIELD_TYPES?.CONTACT,
  emptyText = '-',
  className = '',
}) => {
  const { hasRevealPermission, revealedPii, isRevealing, reveal } =
    usePiiReveal({ userId });

  const revealedValue =
    field === PII_FIELD_TYPES?.EMAIL
      ? revealedPii?.email
      : revealedPii?.contactNo;
  const displayValue = revealedValue || value;

  if (!displayValue) {
    return emptyText;
  }

  return (
    <span className={`pii-value ${className}`}>
      <span className="pii-value-text" title={displayValue}>
        {displayValue}
      </span>
      {hasRevealPermission && userId && !revealedValue ? (
        <RevealPiiButton onClick={reveal} isRevealing={isRevealing} />
      ) : null}
    </span>
  );
};

export default RevealPiiValue;
